import { paths } from '@/routes/paths';

export const QUICK_START: { title: string; sub: string; icon: string; path: string }[] = [
  {
    title: 'Strategic buyer list',
    sub: 'Corporates + strategics',
    icon: 'bi-people',
    path: paths.strategic,
  },
  {
    title: 'PE / financial buyer list',
    sub: 'Funds, sponsors, family offices',
    icon: 'bi-clock',
    path: paths.financialVerticals,
  },
  {
    title: 'Target list',
    sub: 'Corporates',
    icon: 'bi-bullseye',
    path: paths.targetList,
  },
];

export const SEARCH_CHIPS: { label: string; path: string; prompt: string }[] = [
  {
    label: 'Strategic buyers - healthcare IT',
    path: paths.strategic,
    prompt: 'Strategic buyers for a healthcare IT company with $3-6M EBITDA',
  },
  {
    label: 'PE buyers - manufacturing',
    path: paths.financialVerticals,
    prompt: 'Lower-middle-market manufacturing company in the Southeast US',
  },
  {
    label: 'Add-on targets - dental services',
    path: paths.targetList,
    prompt: 'Acquisition targets for a PE-backed dental services platform looking for add-ons',
  },
  {
    label: 'Targets - B2B SaaS $2M ARR',
    path: paths.targetList,
    prompt: 'B2B SaaS companies with around $2M ARR',
  },
];

export const MODE_PATH: Record<string, string> = {
  target: paths.targetList,
  strategic: paths.strategic,
  financial: paths.financialVerticals,
};

export const MAX_ATTACHMENTS = 5;
export const MAX_FILE_MB = 8;
export const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;
export const ATTACH_ACCEPT = '.pdf,.docx,.xlsx,.xls,.csv,.txt';

export const MANDATE_PLACEHOLDER =
  'Ex. Looking to build a target list of US consumer product companies between $20M to $30M revenue';
